import { render } from "./ShowSettings.vue?vue&type=template&id=24fe0320&ts=true"
import script from "./ShowSettings.vue?vue&type=script&lang=ts"
export * from "./ShowSettings.vue?vue&type=script&lang=ts"

import "./ShowSettings.vue?vue&type=style&index=0&id=24fe0320&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__